/* global theme_vars */

export const getStarsUrl = (rating: number): string => {
  const baseUrl = '/wp-content/assets/icons/trustpilot/stars';

  if (rating < 0.2) {
    return `${baseUrl}/0.svg`;
  }

  if (rating < 0.7) {
    return `${baseUrl}/0.5.svg`;
  }

  if (rating < 1.2) {
    return `${baseUrl}/1.svg`;
  }

  if (rating < 1.7) {
    return `${baseUrl}/1.5.svg`;
  }

  if (rating < 2.2) {
    return `${baseUrl}/2.svg`;
  }

  if (rating < 2.7) {
    return `${baseUrl}/2.5.svg`;
  }

  if (rating < 3.2) {
    return `${baseUrl}/3.svg`;
  }

  if (rating < 3.7) {
    return `${baseUrl}/3.5.svg`;
  }

  if (rating < 4.2) {
    return `${baseUrl}/4.svg`;
  }

  if (rating < 4.7) {
    return `${baseUrl}/4.5.svg`;
  }

  return `${baseUrl}/5.svg`;
};

export const getStarLabel = (rating: number): string => {
  if (rating < 1.8) {
    return window.theme_vars.trustpilot.veryBad;
  }

  if (rating < 2.8) {
    return window.theme_vars.trustpilot.bad;
  }

  if (rating < 3.8) {
    return window.theme_vars.trustpilot.good;
  }

  if (rating < 4.3) {
    return window.theme_vars.trustpilot.veryGood;
  }

  return window.theme_vars.trustpilot.excellent;
};

export const formatAverageRating = (average: number | null): string | null => {
  return average ? average.toFixed(1) : null;
};

export const formatNumberOfRatings = (total: number | null): string | null => {
  return total ? total.toLocaleString() : null;
};
